import React from "react";
import { StatefulMenu } from "baseui/menu";

export default function ContextMenu(props) {
  return (
    <StatefulMenu
      items={props.items}
      onItemSelect={({ item }) => props.onMenuItemClick(item)}
      overrides={{
        List: {
          style: {
            width: "100%",
            height: "100%",
            margin: "0px",
          },
        },
      }}
    />
  );
}
